// Import Tailwind CSS
import './main.css';

// Theme JavaScript entry point
console.log('Flash Global SIM theme loaded');

document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle with slide animation
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');
  const mobileMenuPanel = document.querySelector('[data-mobile-menu-panel]');
  const hamburgerIcon = document.querySelector('[data-hamburger-icon]');
  const closeIcon = document.querySelector('[data-close-icon]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchBar = document.querySelector('[data-search-bar]');
  const header = document.querySelector('[data-header]');
  const logo = document.querySelector('[data-logo]');

  // Track scroll position for body scroll lock
  let scrollPosition = 0;

  function openMobileMenu() {
    if (mobileMenuOverlay && mobileMenuPanel) {
      mobileMenuOverlay.classList.remove('hidden');

      // Save current scroll position
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Lock body scroll using position: fixed technique
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
      document.body.classList.add('overflow-hidden');

      // Make header solid white when menu is open
      if (header) {
        header.classList.add('header-menu-open');
        header.classList.remove('header-transparent');
        // Swap to dark logo
        if (logo) {
          logo.src = logo.dataset.logoDark;
        }
      }

      // Update aria-expanded
      if (mobileMenuToggle) {
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
      }

      // Fade hamburger out, X in (only manage opacity)
      if (hamburgerIcon && closeIcon) {
        hamburgerIcon.classList.add('opacity-0');
        closeIcon.classList.remove('opacity-0');
      }

      // Trigger slide animation on next frame
      setTimeout(function() {
        mobileMenuPanel.classList.remove('-translate-x-full');
        mobileMenuPanel.classList.add('translate-x-0');
      }, 10);
    }
  }

  function closeMobileMenu() {
    if (mobileMenuOverlay && mobileMenuPanel) {
      // Update aria-expanded
      if (mobileMenuToggle) {
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      }

      // Remove menu-open class and restore header state based on scroll position and page
      if (header) {
        header.classList.remove('header-menu-open');

        const isHomepage = header.hasAttribute('data-homepage');
        const scrollY = window.scrollY || scrollPosition;

        if (isHomepage && scrollY <= 50) {
          // Restore transparent state on homepage at top
          header.classList.remove('header-scrolled');
          header.classList.add('header-transparent');
          // Swap to white logo
          if (logo) {
            logo.src = logo.dataset.logoWhite;
          }
        } else {
          // Keep scrolled state
          header.classList.add('header-scrolled');
        }
      }

      // Fade X out, hamburger in (only manage opacity)
      if (hamburgerIcon && closeIcon) {
        hamburgerIcon.classList.remove('opacity-0');
        closeIcon.classList.add('opacity-0');
      }

      // Slide out
      mobileMenuPanel.classList.remove('translate-x-0');
      mobileMenuPanel.classList.add('-translate-x-full');

      // Wait for animation to complete before hiding
      setTimeout(function() {
        mobileMenuOverlay.classList.add('hidden');

        // Unlock body scroll and restore scroll position
        document.body.classList.remove('overflow-hidden');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollPosition);
      }, 300);
    }
  }

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function() {
      const isOpen = mobileMenuToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function() {
      searchBar.classList.toggle('hidden');
      if (!searchBar.classList.contains('hidden')) {
        const searchInput = searchBar.querySelector('input');
        if (searchInput) {
          searchInput.focus();
        }
      }
    });
  }

  // Update cart count when items are added/removed
  document.addEventListener('cart:updated', function(event) {
    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) {
      const count = event.detail.item_count || 0;
      cartCount.textContent = count;
      cartCount.style.display = count > 0 ? 'flex' : 'none';
    }
  });

  // Desktop dropdown menu functionality
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  if (dropdowns.length) {
    dropdowns.forEach(function(dropdown) {
      const button = dropdown.querySelector('[data-dropdown-button]');
      const panel = dropdown.querySelector('[data-dropdown-panel]');

      if (button && panel) {
        button.addEventListener('click', function(event) {
          event.stopPropagation();
          const isExpanded = button.getAttribute('aria-expanded') === 'true';

          // Close all other open dropdowns first
          document.querySelectorAll('[data-dropdown-button][aria-expanded="true"]').forEach(function(b) {
            if (b !== button) {
              b.setAttribute('aria-expanded', 'false');
              const p = b.nextElementSibling;
              p.classList.remove('opacity-100', 'scale-100');
              p.classList.add('opacity-0', 'scale-95');
              setTimeout(function() { p.style.display = 'none'; }, 200);
            }
          });

          // Toggle the current dropdown
          if (isExpanded) {
            button.setAttribute('aria-expanded', 'false');
            panel.classList.remove('opacity-100', 'scale-100');
            panel.classList.add('opacity-0', 'scale-95');
            setTimeout(function() { panel.style.display = 'none'; }, 200);
          } else {
            button.setAttribute('aria-expanded', 'true');
            panel.style.display = 'block';
            setTimeout(function() {
              panel.classList.remove('opacity-0', 'scale-95');
              panel.classList.add('opacity-100', 'scale-100');
            }, 10);
          }
        });
      }
    });

    // Global click listener to close dropdowns
    document.addEventListener('click', function() {
      document.querySelectorAll('[data-dropdown-button][aria-expanded="true"]').forEach(function(button) {
        const panel = button.nextElementSibling;
        button.setAttribute('aria-expanded', 'false');
        panel.classList.remove('opacity-100', 'scale-100');
        panel.classList.add('opacity-0', 'scale-95');
        setTimeout(function() { panel.style.display = 'none'; }, 200);
      });
    });
  }

  // Mobile menu dropdown functionality with slide animation
  const mobileDropdowns = document.querySelectorAll('[data-mobile-dropdown]');

  if (mobileDropdowns.length) {
    mobileDropdowns.forEach(function(dropdown) {
      const toggle = dropdown.querySelector('[data-mobile-dropdown-toggle]');
      const panel = dropdown.querySelector('[data-mobile-dropdown-panel]');
      const icon = dropdown.querySelector('[data-mobile-dropdown-icon]');

      if (toggle && panel && icon) {
        toggle.addEventListener('click', function() {
          const isOpen = panel.style.maxHeight && panel.style.maxHeight !== '0px';

          // Toggle the current dropdown
          if (isOpen) {
            // Collapse
            panel.style.maxHeight = '0px';
            icon.classList.remove('rotate-180');
          } else {
            // Expand - calculate the full height
            panel.style.maxHeight = panel.scrollHeight + 'px';
            icon.classList.add('rotate-180');
          }
        });
      }
    });
  }

  // Language modal functionality
  const languageSwitcher = document.querySelector('[data-language-switcher]');
  const languageModalOverlay = document.querySelector('[data-language-modal-overlay]');
  const languageModalPanel = document.querySelector('[data-language-modal-panel]');
  const languageModalClose = document.querySelector('[data-language-modal-close]');

  function openLanguageModal() {
    if (languageModalOverlay && languageModalPanel) {
      languageModalOverlay.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');

      // Trigger slide up animation on next frame
      setTimeout(function() {
        languageModalPanel.classList.remove('translate-y-full');
        languageModalPanel.classList.add('translate-y-0');
      }, 10);
    }
  }

  function closeLanguageModal() {
    if (languageModalOverlay && languageModalPanel) {
      languageModalPanel.classList.remove('translate-y-0');
      languageModalPanel.classList.add('translate-y-full');

      // Wait for animation to complete before hiding
      setTimeout(function() {
        languageModalOverlay.classList.add('hidden');
        document.body.classList.remove('overflow-hidden');
      }, 300);
    }
  }

  if (languageSwitcher) {
    languageSwitcher.addEventListener('click', openLanguageModal);
  }

  if (languageModalClose) {
    languageModalClose.addEventListener('click', closeLanguageModal);
  }

  // Close on backdrop click
  if (languageModalOverlay) {
    languageModalOverlay.addEventListener('click', function(e) {
      if (e.target.classList.contains('bg-opacity-50')) {
        closeLanguageModal();
      }
    });
  }

  // Background images now handled directly by hero section's <picture> element
});